
export const loadMapData = async () => {
  const data_sample = require('./data_sample.json');
  const data = data_sample;
  return data;
};

